import { useTranslation } from 'react-i18next';

import { AvatarSection } from '@/pages/auth/avatar-section';
import { PasswordSection } from '@/pages/auth/password-section';
import { ProfileSection } from '@/pages/auth/profile-section';
import { TwoFactorSection } from '@/pages/auth/two-factor-section';

/**
 * The public app's account screen (gated by <RequireAuth>). Composes the
 * profile / password / avatar / 2FA sections (the in-game login token has
 * its own page: /token).
 */
export default function SettingsPage() {
  const { t } = useTranslation('auth');

  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-5">
      <h1 className="font-display text-strong mb-6 text-2xl">{t('settings.title')}</h1>
      <div className="flex flex-col gap-5">
        <ProfileSection />
        <AvatarSection />
        <PasswordSection />
        <TwoFactorSection />
      </div>
    </div>
  );
}
